module.exports = __webpack_public_path__ + "static/media/br15.fd056884.jpg";